// t() reads the page language, which the compiler cannot see, and this stays
// on screen while the language changes.
"use no memo";
import type { ReactNode } from "react";
import { setLocale, t, useLocale } from "../i18n";
import { Wave } from "../ui/components";

// The header for anyone with no account: the brand and the language switch.
export function SiteHeader({ children }: { children?: ReactNode }) {
  const locale = useLocale();
  return (
    <header className="site-header">
      <a href="/" className="brand" aria-label={t("رنّة — الرئيسية")}>
        <Wave />
        <span>{t("رنّة")}</span>
      </a>
      <div className="header-nav">
        <button
          className="language-button"
          lang={locale === "ar" ? "en" : "ar"}
          aria-label={locale === "ar" ? "Switch to English" : "التبديل للعربية"}
          onClick={() => setLocale(locale === "ar" ? "en" : "ar")}
        >
          {locale === "ar" ? "EN" : "عربي"}
        </button>
        {children}
      </div>
    </header>
  );
}
